import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { submitFormData } from '../../../../pages/api';
import apiClient from '../../../../pages/keycloak/axiosInstance';

const PottingMaterial = ({ globalFields, formData, onFormDataChange }) => {
    const [localFormData, setLocalFormData] = useState(formData);
    const [uploadedImages, setUploadedImages] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImageUrl, setSelectedImageUrl] = useState('');
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    // Sync local state with props
    useEffect(() => {
        setLocalFormData(formData);
    }, [formData]);

    // Prefill data from sessionStorage
    useEffect(() => {
        const isFormDataEmpty = Object.values(formData).every(
            (value) => value === '' || value === null || value === undefined
        );

        if (isFormDataEmpty) {
            const inspectionData = sessionStorage.getItem('inspectionData');
            if (inspectionData) {
                try {
                    const parsedData = JSON.parse(inspectionData);
                    const pottingMaterialData = parsedData?.BOM?.pottingMaterial;

                    if (pottingMaterialData) {
                        setLocalFormData((prevData) => ({
                            ...prevData,
                            make: pottingMaterialData.make || prevData.make,
                            model: pottingMaterialData.model || prevData.model,
                            lotNo: pottingMaterialData.lotNo || prevData.lotNo,
                            manufacturingDateA: pottingMaterialData.manufacturingDateA || prevData.manufacturingDateA,
                            expiryMonitoringA: pottingMaterialData.expiryMonitoringA || prevData.expiryMonitoringA,
                            manufacturingDateB: pottingMaterialData.manufacturingDateB || prevData.manufacturingDateB,
                            expiryMonitoringB: pottingMaterialData.expiryMonitoringB || prevData.expiryMonitoringB,
                            remarks: pottingMaterialData.remarks || prevData.remarks,
                        }));
                    }
                } catch (error) {
                    console.error('Error parsing inspectionData:', error);
                }
            }
        }
    }, []);

    // Fetch uploaded images
    useEffect(() => {
        const fetchUploadedImages = async () => {
            try {
                const projectId = localStorage.getItem('selectedProject');
                const inspectionDate = sessionStorage.getItem('inspectionDate');
                const inspectionSupplier = sessionStorage.getItem('inspectionSupplier');
                const inspectionShift = sessionStorage.getItem('inspectionShift');

                const response = await apiClient.get(`get_uploaded_inspection_files`, {
                    params: {
                        projectId,
                        inspectionSupplier,
                        inspectionDate,
                        inspectionShift,
                        formName: 'PottingMaterial',
                        inputFieldId: 'Upload PhotoPottingMaterial'
                    }
                });
                setUploadedImages(response.data.files || []);
            } catch (error) {
                console.error('Error fetching uploaded images:', error);
            }
        };

        fetchUploadedImages();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedData = { ...localFormData, [name]: value };
        setLocalFormData(updatedData);
        onFormDataChange(updatedData);
    };

    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = (error) => reject(error);
        });
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        const updatedData = { ...localFormData, uploadPhoto: files };
        setLocalFormData(updatedData);
        onFormDataChange(updatedData);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const mfgDateA = new Date(localFormData.manufacturingDateA);
        const expDateA = new Date(localFormData.expiryMonitoringA);
        const mfgDateB = new Date(localFormData.manufacturingDateB);
        const expDateB = new Date(localFormData.expiryMonitoringB);
    
        if (mfgDateA >= expDateA) {
            alert('Manufacturing Date A must be earlier than Expiry Date A. Please enter a valid date.');
            return;
        }
    
        if (mfgDateB >= expDateB) {
            alert('Manufacturing Date B must be earlier than Expiry Date B. Please enter a valid date.');
            return;
        }

        const projectId = localStorage.getItem('selectedProject');
        const inspectionDate = sessionStorage.getItem('inspectionDate');
        const inspectionShift = sessionStorage.getItem('inspectionShift');
        const inspectorName = sessionStorage.getItem('username');
        const inspectionSupplier = sessionStorage.getItem('inspectionSupplier');

        

        try {
            // Upload files if any
            if (localFormData.uploadPhoto && Array.isArray(localFormData.uploadPhoto) && localFormData.uploadPhoto.length > 0) {
                const base64Files = await Promise.all(
                    localFormData.uploadPhoto.map(async (file) => ({
                        inputFieldId: 'Upload PhotoPottingMaterial',
                        file: await convertToBase64(file),
                        filename: file.name,
                    }))
                );

                await apiClient.post(`upload_inspection_files`, {
                    projectId,
                    inspectionSupplier,
                    inspectionDate,
                    inspectionShift,
                    inspectorName,
                    formName: 'PottingMaterial',
                    files: base64Files
                });

                // Refresh uploaded images
                const response = await apiClient.get(`get_uploaded_inspection_files`, {
                    params: {
                        projectId,
                        inspectionSupplier,
                        inspectionDate,
                        inspectionShift,
                        formName: 'PottingMaterial',
                        inputFieldId: 'Upload PhotoPottingMaterial'
                    }
                });
                setUploadedImages(response.data.files || []);
            }

            // Submit form data
            const payload = {
                projectId,
                inspectionSupplier,
                inspectionDate,
                inspectionShift,
                inspectorName,
                status: 'completed',
                BOM: {
                    pottingMaterial: {
                        make: localFormData.make,
                        model: localFormData.model,
                        lotNo: localFormData.lotNo,
                        manufacturingDateA: localFormData.manufacturingDateA,
                        expiryMonitoringA: localFormData.expiryMonitoringA,
                        manufacturingDateB: localFormData.manufacturingDateB,
                        expiryMonitoringB: localFormData.expiryMonitoringB,
                        remarks: localFormData.remarks,
                    },
                },
            };

            const response = await submitFormData(payload);
            alert('Form submitted successfully');
        } catch (error) {
            console.error('Error submitting form or uploading files:', error);
            alert('Failed to submit form or upload files');
        }
    };

    const openModal = (url) => {
        setSelectedImageUrl(url);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImageUrl('');
    };

    return (
        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-lg space-y-4">
            <h2 className="text-2xl font-semibold mb-4">Potting Material</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Make */}
                <div>
                    <label className="block font-semibold mb-1">Make</label>
                    <input
                        type="text"
                        name="make"
                        value={localFormData.make || ''}
                        onChange={handleChange}
                        placeholder="Make"
                        className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                {/* Model */}
                <div>
                    <label className="block font-semibold mb-1">Model</label>
                    <input
                        type="text"
                        name="model"
                        value={localFormData.model || ''}
                        onChange={handleChange}
                        placeholder="Model"
                        className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                {/* Lot No. */}
                <div>
                    <label className="block font-semibold mb-1">Lot No. (Barcode Scan)</label>
                    <input
                        type="text"
                        name="lotNo"
                        value={localFormData.lotNo || ''}
                        onChange={handleChange}
                        placeholder="Scan the barcode"
                        className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                {/* Manufacturing Date (A) */}
                <div>
                    <label className="block font-semibold mb-1">Manufacturing Date (A)</label>
                    <input
                        type="date"
                        name="manufacturingDateA"
                        value={localFormData.manufacturingDateA || ''}
                        onChange={handleChange}
                        className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                {/* Expiry Monitoring as Per QAP (A) */}
                <div>
                    <label className="block font-semibold mb-1">Expiry Monitoring as Per QAP (A)</label>
                    <input
                        type="date"
                        name="expiryMonitoringA"
                        value={localFormData.expiryMonitoringA || ''}
                        onChange={handleChange}
                        className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                {/* Manufacturing Date (B) */}
                <div>
                    <label className="block font-semibold mb-1">Manufacturing Date (B)</label>
                    <input
                        type="date"
                        name="manufacturingDateB"
                        value={localFormData.manufacturingDateB || ''}
                        onChange={handleChange}
                        className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                {/* Expiry Monitoring as Per QAP (B) */}
                <div>
                    <label className="block font-semibold mb-1">Expiry Monitoring as Per QAP (B)</label>
                    <input
                        type="date"
                        name="expiryMonitoringB"
                        value={localFormData.expiryMonitoringB || ''}
                        onChange={handleChange}
                        className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                {/* Upload Photo */}
                <div>
                    <label className="block font-semibold mb-1">Upload Photo</label>
                    <input
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    {localFormData.uploadPhoto && Array.isArray(localFormData.uploadPhoto) && (
                        <div className="text-gray-600 mt-1">
                            {localFormData.uploadPhoto.map((file, index) => (
                                <p key={index}>{file.name}</p>
                            ))}
                        </div>
                    )}
                </div>
                {/* Display Uploaded Images */}
                <div className="col-span-full">
                    <label className="block font-semibold mb-1">Uploaded Images</label>
                    {uploadedImages.length > 0 ? (
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            {uploadedImages.map((image, index) => (
                                <div key={index} className="relative">
                                    <img
                                        src={image.url}
                                        alt={image.filename || `Uploaded ${index}`}
                                        className="w-full h-32 object-cover rounded cursor-pointer"
                                        onClick={() => openModal(image.url)}
                                    />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-gray-500">No images uploaded.</p>
                    )}
                </div>
                {/* Remarks */}
                <div className="col-span-full">
                    <label className="block font-semibold mb-1">Remarks (In case of non-conformance)</label>
                    <textarea
                        name="remarks"
                        value={localFormData.remarks || ''}
                        onChange={handleChange}
                        placeholder="Remarks"
                        className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    ></textarea>
                </div>
            </div>
            {/* Modal for Full Image View */}
            {isModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="relative bg-white p-4 rounded-lg max-w-4xl max-h-[90vh]">
                        <button
                            className="absolute top-2 right-2 text-black text-2xl font-bold"
                            onClick={closeModal}
                        >
                            ×
                        </button>
                        <img
                            src={selectedImageUrl}
                            alt="Full view"
                            className="max-w-full max-h-[80vh] object-contain"
                        />
                    </div>
                </div>
            )}
            {/* Submit Button */}
            <button
                type="submit"
                className="mt-4 bg-[#424752] text-white px-4 py-2 rounded hover:bg-gray-500 transition-colors"
            >
                Submit
            </button>
        </form>
    );
};

export default PottingMaterial;